import { useTheme } from '@mui/material/styles';
import {
	Grid,
	Card,
	CardContent,
	IconButton,
	useMediaQuery,
	Divider,
	Button,
	Typography,
	Box,
	List,
	Avatar,
	ImageList,
	ImageListItem,
	ListItem,
	ListItemText,
	ListItemAvatar,
	CardActions,
	ToggleButtonGroup,
	ToggleButton,
} from '@mui/material';
import { WebSharp as WebSharpIcon } from '@mui/icons-material';
import { m, LazyMotion } from 'framer-motion';
const loadFeatures = () => import('~/utils/framerFeatures').then((res) => res.domAnimation);
import { useTranslation } from 'react-i18next';

// import codeIcon from '~/content/svg/icons/code-solid.svg';
// import webIcon from '~/content/svg/icons/web.svg';
// import code2Icon from '~/content/svg/icons/code.svg';
// import apiIcon from '~/content/svg/icons/api.svg';
// import cloudIcon from '~/content/svg/icons/cloud.svg';

const Reviews = (): JSX.Element => {
	let { t } = useTranslation(['applications']);

	const mock = [
		{
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					fill='currentColor'
					viewBox='0 0 48 48'
					height='48'
					width='48'
				>
					<path d='m18.95 30.85 2.2-2.2L16.5 24l4.6-4.6-2.2-2.2-6.8 6.8Zm10.1 0L35.9 24l-6.85-6.85-2.2 2.2L31.5 24l-4.65 4.65ZM6 42V6h36v36Zm3-3h30V9H9Zm0 0V9v30Z' />
				</svg>
			),
			title: t('reviews_title_1'),
			subtitle: t('reviews_subtitle_1'),
		},
		{
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					fill='currentColor'
					viewBox='0 0 48 48'
					height='48'
					width='48'
				>
					<path d='M12.55 40q-4.4 0-7.475-3.075Q2 33.85 2 29.45q0-3.9 2.5-6.85 2.5-2.95 6.35-3.55 1-4.85 4.7-7.925T24.1 8.05q5.6 0 9.45 4.075Q37.4 16.2 37.4 21.9v1.2q3.6-.1 6.1 2.325Q46 27.85 46 31.55q0 3.45-2.5 5.95T37.55 40Zm0-3h25q2.25 0 3.85-1.6t1.6-3.85q0-2.25-1.6-3.85t-3.85-1.6H34.4v-4.2q0-4.55-3.05-7.7-3.05-3.15-7.45-3.15t-7.475 3.15q-3.075 3.15-3.075 7.7h-.95q-3.1 0-5.25 2.175T5 29.45q0 3.15 2.2 5.35Q9.4 37 12.55 37ZM24 24Z' />
				</svg>
			),
			title: t('reviews_title_2'),
			subtitle: t('reviews_subtitle_2'),
		},
		{
			icon: (
				<svg
					xmlns='http://www.w3.org/2000/svg'
					fill='currentColor'
					viewBox='0 0 48 48'
					height='48'
					width='48'
				>
					<path d='M11.7 46q-2.35 0-4.025-1.675Q6 42.65 6 40.3q0-2.4 1.675-4.05T11.7 34.6q.7 0 1.225.125.525.125 1.075.375l4.25-5.3q-.95-1.15-1.45-2.625t-.25-3.075l-6.05-2.05Q9.75 23.3 8.525 24t-2.825.7q-2.35 0-4.025-1.675Q0 21.35 0 19q0-2.4 1.675-4.05T5.7 13.3q2.4 0 4.05 1.65T11.4 19v.2l6.1 2.1q.9-1.6 2.175-2.45 1.275-.85 2.825-1.2V11.2q-1.95-.55-3.075-2.15Q18.3 7.45 18.3 5.7q0-2.4 1.675-4.05T24 0q2.4 0 4.05 1.65T29.7 5.7q0 1.75-1.15 3.35T25.5 11.2v6.45q1.55.35 2.85 1.2t2.2 2.45l6.05-2.1V19q0-2.4 1.675-4.05T42.3 13.3q2.4 0 4.05 1.65T48 19q0 2.35-1.65 4.025Q44.7 24.7 42.3 24.7q-1.6 0-2.85-.7t-1.95-1.95l-6.05 2.05q.25 1.6-.225 3.075T29.75 29.8L34 35.1q.55-.25 1.075-.375.525-.125 1.225-.125 2.4 0 4.05 1.65T42 40.3q0 2.35-1.65 4.025Q38.7 46 36.3 46q-2.35 0-4.025-1.675Q30.6 42.65 30.6 40.3q0-1 .275-1.8t.775-1.55l-4.25-5.3q-1.6.85-3.425.85-1.825 0-3.425-.85L16.35 37q.5.75.775 1.525.275.775.275 1.775 0 2.35-1.65 4.025Q14.1 46 11.7 46Zm-6-24.3q1.15 0 1.925-.775Q8.4 20.15 8.4 19t-.775-1.925Q6.85 16.3 5.7 16.3t-1.925.775Q3 17.85 3 19t.775 1.925q.775.775 1.925.775Zm6 21.3q1.15 0 1.925-.775.775-.775.775-1.925t-.775-1.925Q12.85 37.6 11.7 37.6t-1.925.775Q9 39.15 9 40.3t.775 1.925Q10.55 43 11.7 43ZM24 8.4q1.15 0 1.925-.775.775-.775.775-1.925t-.775-1.925Q25.15 3 24 3t-1.925.775Q21.3 4.55 21.3 5.7t.775 1.925Q22.85 8.4 24 8.4Zm.05 21.1q1.85 0 3.15-1.325 1.3-1.325 1.3-3.225 0-1.85-1.3-3.15-1.3-1.3-3.2-1.3-1.85 0-3.175 1.3Q19.5 23.1 19.5 25q0 1.85 1.325 3.175Q22.15 29.5 24.05 29.5ZM36.3 43q1.15 0 1.925-.775Q39 41.45 39 40.3t-.775-1.925Q37.45 37.6 36.3 37.6t-1.925.775q-.775.775-.775 1.925t.775 1.925Q35.15 43 36.3 43Zm6-21.3q1.15 0 1.925-.775Q45 20.15 45 19t-.775-1.925Q43.45 16.3 42.3 16.3t-1.925.775Q39.6 17.85 39.6 19t.775 1.925q.775.775 1.925.775ZM24 5.7ZM5.7 19ZM24 25Zm18.3-6ZM11.7 40.3Zm24.6 0Z' />
				</svg>
			),
			title: t('reviews_title_3'),
			subtitle: t('reviews_subtitle_3'),
		},
	];
	// const mock = [
	// 	{
	// 		icon: code2Icon,
	// 		title: 'Individuelle Software Entwicklung',
	// 		subtitle: 'Benutzerdefinierte Softwareanwendungen lauffähig auf Windows, macOS, iPadOS, Android und iOS.'
	// 	},
	// 	{
	// 		icon: cloudIcon,
	// 		title: 'WebApp Entwicklung',
	// 		subtitle:
	// 			'Entwicklung einer Software, welche im Browser ausgeführt wird. Eine Installation ist nicht mehr notwendig.'
	// 	},
	// 	{
	// 		icon: apiIcon,
	// 		title: 'Server/API Entwicklung',
	// 		subtitle: 'APIs sind eine innovative Lösung um die Kommunikation zwischen verschiedenen Anwendungen zu ermöglichen.'
	// 	}
	// ];

	const theme = useTheme();

	return (
		<Box marginBottom={4} marginTop={0}>
			<Grid container spacing={2}>
				{mock.map((item, i) => (
					<Grid item xs={12} md={4} key={i}>
						<Box
							display={'block'}
							width={1}
							height={1}
							sx={{
								textDecoration: 'none',
							}}
						>
							<Box
								component={Card}
								width={1}
								height={1}
								flexDirection={'column'}
								display={'flex'}
								borderRadius={0}
								bgcolor={'transparent'}
								sx={{
									boxShadow: 0,
								}}
							>
								<CardContent
									sx={{
										display: 'flex',
										flexDirection: 'column',
										alignItems: 'flex-start',
									}}
								>
									<LazyMotion strict features={loadFeatures}>
										<m.div
											initial={{ opacity: 0 }}
											whileInView={{ opacity: 1 }}
											transition={{ duration: 0.3, ease: 'linear' }}
											viewport={{
												once: true,
												amount: 0.6,
											}}
										>
											<Box
												component={Avatar}
												width={{ xs: 60, md: 80 }}
												height={{ xs: 60, md: 80 }}
												marginBottom={2}
												bgcolor={'transparent'}
												color={theme.palette.primary.main}
												borderRadius={0}
											>
												{item.icon}
											</Box>
										</m.div>
									</LazyMotion>
									<Typography component='h3' variant={'h6'} gutterBottom sx={{ fontWeight: 600 }}>
										{item.title}
									</Typography>
									<Typography color='text.secondary'>{item.subtitle}</Typography>
								</CardContent>
							</Box>
						</Box>
					</Grid>
				))}
			</Grid>
		</Box>
	);
};

export default Reviews;
